// removed by extract-text-webpack-plugin
module.exports = {"image-wrapper":"Work__image-wrapper___2LIWd","image":"Work__image___1RnmR","portrait":"Work__portrait___2wGPC","title":"Work__title___3gOdQ","details":"Work__details___3qjO-","year":"Work__year___3ZI7q","dimensions":"Work__dimensions___3Lgr0","medium":"Work__medium___E_n3G"};


//////////////////
// WEBPACK FOOTER
// ./application/js/components/Work.css
// module id = 525
// module chunks = 0